module.exports = __webpack_public_path__ + "img/agustina-rabanal.4b0ec67f.jpg";